import { render, staticRenderFns } from "@/modules/GeneralAgent/templates/general-agents-list.html?vue&type=template&id=189841ac&scoped=true&"
import script from "@/modules/GeneralAgent/scripts/general-agents-list.ts?vue&type=script&lang=js&"
export * from "@/modules/GeneralAgent/scripts/general-agents-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/GeneralAgent/styles/general-agents-list.scss?vue&type=style&index=0&id=189841ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189841ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
